module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.eaf026a4.png";